// 全体で利用できる定数の初期化
export const BtixConstant = {
    debugMode: true,
    loginUserType: "user",
    touchOrClickEvent: () => {
        return window.ontouchstart === undefined ? "click" : "touchstart";
    },
    axiosRequestConfig: () => {
        let settings = { withCredentials: true };
        // staging環境で必要なBasic認証のID/PWD
        if (BtixConstant.debugMode) {
            settings = {
                withCredentials: true,
                auth: {
                    username: "btixdev",
                    password: "caretex2dxpo",
                },
            };
        }
        return settings;
    },
    defaultAfterLogoutUrl: "/",
    apiUrl: {
        logIn: "/api/login",
        logOut: "/api/logout",
        validateVipCode: "/api/u/check-vip",
    },
};
